<ng-container  *ngIf="riskNormalized !== 'unknown'">
  <div class="risk-meter {{riskNormalized}}">
    <img src="/assets/images/icon-meter-{{riskNormalized}}-white.svg" alt="Risk Meter Icon"/>
    {{riskLabel}}
  </div>
</ng-container>
<ng-container  *ngIf="riskNormalized === 'unknown'">
  N/A
</ng-container>
